module.exports = __webpack_public_path__ + "img/cabin_bag.d6f7e959.svg";